/** Public server function behind the free site audit tool; the audit itself runs in site-audit.server.ts. */
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import type { AuditFailure, AuditResult } from "./site-audit";

export const auditSite = createServerFn({ method: "POST" })
  .validator((data) => z.object({ url: z.string().min(3).max(300) }).parse(data))
  .handler(async ({ data }): Promise<AuditResult | AuditFailure> => {
    const { runSiteAudit } = await import("./site-audit.server");
    return runSiteAudit(data.url);
  });
